export enum UserTypeEnum {
  FORWARDER = "FORWARDER",
  COLOADER = "COLOADER",
  AIRLINE = "AIRLINE",
  ADMIN = "ADMIN",
  GSA = "GSA",
  STANDARD = "STANDARD",
}
